import React from 'react';
import './Signup.css';
import FadeIn from 'react-fade-in';



//Class to display "Hjelp" button on the seat reservation menu
//Shows modal of legend

export class GDPRModal extends React.Component {





  render() {
    const info = (
    <div className="infoModal">
      <h3> Informasjon om hva vi lagrer om deg </h3>
      <br/>
      <h6>Påmelding hos oss krever at du oppgir personinformasjon.</h6> <br/>
      <h6>Dette består av navn, telefonnummer, epost, alder, og evt. andre behov.</h6>
      <br/>
      <h6>Dette gjelder for inntil 5 personer som du kan melde på.</h6>
      <h6>Sørg for at du har deres samtykke til å fylle inn informasjonen om de.</h6>
      <br/>
      <h6>Betaling via Vipps skjer i forhold til Vipps sine egne rettningslinjer.</h6>
      <p>Vi sletter all brukerdata etter maksimalt 6 måneder.</p>
      <p>Vi deler ikke din brukerdata med noen.</p>
      <p>Ved å melde deg på, godtar du disse betingelsene.</p>

 
    </div> )



    return (
      <div className="seatModal">
      <FadeIn>
        {info}
        <div className="btnSpace">
        <button className="btn btno btn-danger help" onClick={this.props.closeGDPRModal}> Tilbake </button>
        </div>
        </FadeIn>
      </div>

    );
  }
}

export default GDPRModal;




// WEBPACK FOOTER //
// ./src/Components/Signup/GDPRModal.js